// extracted by mini-css-extract-plugin
export default {"checkbox":"IQLw5Z","checkboxError":"Yn9nJd"};